import { useMutation } from '@apollo/client'
import { Box, FormModal, Link, Text } from '@chaine/keychaine'
import React, { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'

import { Toast } from '../../../_shared/components/toast'
import { validations } from '../../../_utils/validations/validations'
import { AppModalProps } from '../components/apps-data'
import { ENABLE_SONAR_APP } from '../data/mutations'

/**
 * Generate's an api key for Tai to use in addition to input an api key from Tai.
 * @param props.app the app
 * @param props.isOpen sets the modal to open or closed
 * @param props.onClose closes the modal
 */
const SonarAppModal = React.memo((props: AppModalProps) => {
  const { isOpen, onClose, appType, app } = props
  const [formError, setFormError] = useState('')

  const { showToast } = Toast()

  const [enableSonarApp, { loading: enableAppLoading }] = useMutation(ENABLE_SONAR_APP, {
    onCompleted: () => {
      showToast({ status: 'success', title: 'Sonar App Enabled' })
      onClose()
    },
    onError: (error) => {
      showToast({ status: 'error', title: error.message })
    }
  })

  const footer = (
    <Box>
      <Text color="red.600">{formError}</Text>
      <Text>
        {`See `}
        <Link color="blue.600" href={app.docs} target="_blank" rel="noopener noreferrer">
          detailed steps here.
        </Link>
      </Text>
    </Box>
  )

  type FieldValues = { sonarPassword?: string; username?: string }
  const handleSaveDetails: SubmitHandler<FieldValues> = (event) => {
    const { username, sonarPassword } = event
    enableSonarApp({
      variables: { appType: appType, password: sonarPassword, username }
    })
  }

  const closeModal = () => {
    setFormError('')
    onClose()
  }
  return (
    <>
      <FormModal
        isOpen={isOpen}
        onClose={closeModal}
        title={`Enable ${appType} for Chaine`}
        subtitle={`Sonar integration requires an API username and password. Please request from your sales or support rep at Sonar.`}
        formSubmitHandler={handleSaveDetails}
        buttonText={'Enable'}
        initialValues={{}}
        validations={validations}
        isLoading={enableAppLoading}
        footer={footer}
        modalItems={[
          {
            labelText: "Sonar API User's username",
            name: 'username',
            placeHolder: 'Enter your Sonar API User username',
            type: 'input'
          },
          {
            labelText: "Sonar API User's password",
            name: 'sonarPassword',
            placeHolder: 'Enter your Sonar API User password',
            type: 'input'
          }
        ]}
      />
    </>
  )
})

SonarAppModal.displayName = 'SonarApp'

export { SonarAppModal }
